import React, { useEffect, useState } from "react";
import styles from "./Host.module.css";
import { RoomAssignment } from "store/user/types";
import { useHost } from "./useHost";

interface HostProps {
  roomUid: string;
}

/** This is an experimental page. */
/** FOR DEV TESTING ONLY */
export const Host: React.FC<HostProps> = ({ roomUid }) => {
  const {
    authenticated,
    knocking,
    guests,
    update,
    move,
    startRoomAsHost,
  } = useHost(roomUid);
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [greenRoomParticipants, setGreenRoomParticipants] = useState<any[]>([]);
  const [liveBroadcastParticipants, setLiveBroadcastParticipants] = useState<
    any[]
  >([]);

  useEffect(() => {
    if (guests) {
      const greenRoom = guests
        .filter((g) => (g.data as any).area === RoomAssignment.GreenRoom)
        .map((g) => g.key);
      const lb = guests
        .filter((g) => (g.data as any).area === RoomAssignment.LiveBroadcast)
        .map((g) => g.key);
      setGreenRoomParticipants(greenRoom);
      setLiveBroadcastParticipants(lb);
    }
  }, [guests]);

  return (
    <div className={styles["room"]}>
      {!authenticated ? (
        <form onSubmit={(e) => { 
          e.preventDefault(); 
          startRoomAsHost(username, password); 
          }}>
          <label htmlFor="username">Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <label htmlFor="password">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit">Authenticate</button>
        </form>
      ) : (
        <>
          <h2>Knocking:</h2>
          <ul>
            {knocking.map((k: any) => {
              return (
                <div key={(k.data as any).id + "-knocking"}>
                  <li>
                    {k.data.name} ({k.data.status})
                  </li>
                  {k.data.status === "waiting" && <button
                    onClick={() =>
                      update(k.index, { ...k.data, status: "admitted" })
                    }
                  >
                    Admit
                  </button>}
                  {k.data.status === "admitted" && <button
                    onClick={() =>
                      update(k.index, { ...k.data, status: "waiting" })
                    }
                  >
                    Exclude
                  </button>}
                  <button
                    onClick={() =>
                      update(k.index, { ...k.data, status: "rejected" })
                    }
                  >
                    Remove
                  </button>
                </div>
              );
            })}
          </ul>

          <h2>Green Room:</h2>
          <ul>
            {greenRoomParticipants &&
              greenRoomParticipants.map((v, i) => (
                <div key={v + "-greenroom"}>
                  <li>
                    {v}
                  </li>
                  <button onClick={() => move(v, RoomAssignment.LiveBroadcast)}>
                    To Live Broadcast
                  </button>
                </div>
              ))}
          </ul>

          <h2>Live Broadcast:</h2>
          <ul>
            {liveBroadcastParticipants &&
              liveBroadcastParticipants.map((v, i) => (
                <div key={v + "-live"}>
                  <li>
                    {v}
                  </li>
                  <button onClick={() => move(v, RoomAssignment.GreenRoom)}>
                    To Green Room
                  </button>
                </div>
              ))}
          </ul>
        </>
      )}
    </div>
  );
};
